import { styled } from "../../theme";

export const Container = styled.div`
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    flex-direction: column;
  }
`;

export const TextColumn = styled.div`
  width: 50%;
  max-width: 50%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 100%;
    max-width: 100%;
  }
`;
export const TextTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top: 2em;
  position: absolute;
  top: 0;
  text-transform:uppercase;
  .title_level_2 {
    color: ${({ theme }) => theme.color.primary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.primary} solid;
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 3em;
  }
`;
